import { DropDownMenuItem } from '../dropdown-menu/dropdown-menu-item';

// å­¦ä¹ å­æ®éé¡¹æå±ç±»å
export class LearnCertMenuItem extends DropDownMenuItem {

  constructor(public id: number,
              public contentText: string,
              public show: boolean,
              public childrenMenuItem: DropDownMenuItem[] = []) {
    super(id, contentText, false, false, show);
  }

  copy() {
    let children = [];
    this.childrenMenuItem.forEach(item => {
      children.push(item.copy());
    });
    return new LearnCertMenuItem(this.id, this.contentText, this.show, children);
  }
}
